/**
 * @description
 * Objeto VistaRapida
 */

export class VistaRapida {

    public active: boolean = false;

    /** cantidades totales **/
    public totAvisos: number  = 0;
    public totNotifi: number = 0;
    public totTramit: number = 0;
    public totQuejas: number = 0;
    public totExped: number = 0;
    public totEsbor: number = 0;

    public totExpedAjud: number = 0;
    public totExpedTrib: number = 0;
    public totExpedSanc: number = 0;
    public totExpedAltr: number = 0;

    public totNotVig: number = 0;
    public totComVig: number = 0;
    public totAltres: number = 0;
    public totContra: number = 0;
    public totRebuts: number = 0;
    public totRebutPag: number = 0;
    public totRebutPenDins: number = 0;
    public totRebutPenFora: number = 0;
    public totRebutTramtit: number = 0;
    public totRebutAnul: number = 0;
    public totFacturas: number = 0;
    public totFacPag: number = 0;
    public totFacPend: number = 0;
    public totFacIncid: number = 0;

    /** importes totales **/
    public totImportRebuts: number = 0;
    public totImportFact: number = 0;
    public totImportExped: number = 0;
    public totImportContr: number = 0;

    /** subapartados expedientes **/
    public expedCurso: number = 0;
    public expedFinal: number = 0;
    public expedAjud: number = 0;
    public expedTrib: number = 0;
    public expedSanc: number = 0;
    public expedAltr: number = 0;

    public posicioexped: number = 0;

    /** subapartados rebuts **/
    public rebutpagat: number = 0;
    public reubupendins: number = 0;
    public reubupenfora: number = 0;
    public tramitantse: number = 0;
    public rebutanul: number = 0;
    public posiciorebutestat: number = 0;

    /**subapartados factures */
    public factpagat: number = 0;
    public factincid: number = 0;
    public factpende: number = 0;
    public posiciofact: number = 0;

    /*subapartados contractes*/
    public contImporFac: number = 0;
    public contImporNotFac: number = 0;
    public posiciocontrac: number = 0;
    public posicioDescrip: number = 0;

    /*subapartados dades contacte*/
    public email: string;
    public movil: string;
    public telefono: string;
    public fax: string;
    public enlace: string;

    /*subapartados queixas*/
    public posiciofecha: number = 0;

    /*subapartados tramits*/
    public posiciodescat: number = 0;
    public posiciodetacat: number = 0;

    /*subapartados altres serveis*/
    public posicioaltdescat: number = 0;
    public posicioaltdetacat: number = 0;


    /*posicionamiento multiidioma*/
    public textcarpcat: number = 0;
    public textcarpesp: number = 0;

    /*subapartados dades padro*/
    public individual: string;
    public colectivo: string;
    public padroenable: boolean = false;
  
    constructor() {}
}